import type { AiContextLibrary } from "@redotech/redo-model/ai-context-library";
import { AiContextLibrarySchema } from "@redotech/redo-model/ai-context-library";
import * as z from "zod/v4";

export const getContextLibraryItems = {
  name: "getContextLibraryItems" as const,
  input: z.object({
    page: z.number().positive().optional(),
    pageSize: z.number().positive().optional(),
    searchText: z.string().optional(),
  }),
  output: z.object({
    data: z.array(AiContextLibrarySchema as z.ZodType<AiContextLibrary>),
    paginationKey: z.string().optional(),
    totalCount: z.number().optional(),
    currentPage: z.number().optional(),
    totalPages: z.number().optional(),
  }),
};
